import React, { useState, useEffect } from 'react';
import { NavbarLinks } from '../../data/navbarLinks';
import { Link, matchPath, useLocation } from 'react-router-dom';
import { BsChevronDown, BsMoonStars, BsSun } from 'react-icons/bs';
import ServiceTemplate from './ServiceTemplate';
import MobileNavbar from './Homepage/MobileNavbar';
import { useTheme } from '../../ThemeContext';

import Logo from '../../assets/images/bcc_logo.jpeg';
import BLogo from '../../assets/images/bcc_b_logo.png';

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [serviceOpen, setServiceOpen] = useState(false);
  const { isDark, toggleTheme } = useTheme();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const matchRoute = (route) => matchPath({ path: route }, location.pathname);

  return (
    <nav
      id="main-navbar"
      className={`fixed top-0 left-0 right-0 z-[1000] transition-all duration-500 ease-apple
        ${scrolled ? 'py-2' : 'py-3'}`}
    >
      {/* Floating Pill Container */}
      <div
        className={`mx-auto max-w-[1100px] transition-all duration-500 ease-apple
          ${scrolled
            ? 'navbar-pill glass rounded-full shadow-glass dark:shadow-glass-dark border border-transparent mx-4 md:mx-auto'
            : ''
          }`}
      >
        <div className="flex items-center justify-between px-6 py-3 lg:px-8">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group" id="navbar-logo">
            <img src={BLogo} alt="Bombay Coding Company" className="h-10 w-auto rounded-sm object-contain shadow-sm" />
            <span className="text-lg font-bold tracking-tight group-hover:opacity-70 transition-all duration-300"
                  style={{ color: 'var(--text-primary)' }}>
              Bombay Coding Company
            </span>
          </Link>

          {/* Desktop Nav Links */}
          <div className="hidden lg:flex items-center gap-1">
            {NavbarLinks.map((link, index) => (
              <div key={index} className="relative">
                {link.title === 'Services' ? (
                  <div
                    className="relative"
                    onMouseEnter={() => setServiceOpen(true)}
                    onMouseLeave={() => setServiceOpen(false)}
                  >
                    <button
                      id="nav-services-trigger"
                      className={`flex items-center gap-1 rounded-full px-4 py-2 text-sm font-medium transition-all duration-300
                        ${matchRoute('/services/:serviceName')
                          ? 'text-[var(--accent)]'
                          : 'text-[var(--text-secondary)] hover:text-[var(--text-primary)] hover:bg-[var(--accent-soft)]'
                        }`}
                    >
                      {link.title}
                      <BsChevronDown
                        className={`text-[10px] transition-transform duration-300 ${serviceOpen ? 'rotate-180' : ''}`}
                      />
                    </button>

                    {/* Dropdown */}
                    <div
                      className={`absolute left-1/2 top-full mt-2 -translate-x-1/2
                        w-[680px] rounded-2xl glass p-5 transition-all duration-300 origin-top
                        ${serviceOpen
                          ? 'opacity-100 scale-100 translate-y-0 pointer-events-auto'
                          : 'opacity-0 scale-95 -translate-y-2 pointer-events-none'
                        }`}
                      style={{
                        border: '1px solid var(--border-color)',
                        boxShadow: 'var(--shadow-card-hover)'
                      }}
                    >
                      <ServiceTemplate />
                    </div>
                  </div>
                ) : (
                  <Link to={link.path}>
                    <span
                      className={`rounded-full px-4 py-2 text-sm font-medium transition-all duration-300 inline-block
                        ${matchRoute(link?.path)
                          ? 'text-[var(--accent)] bg-[var(--accent-soft)]'
                          : 'text-[var(--text-secondary)] hover:text-[var(--text-primary)] hover:bg-[var(--accent-soft)]'
                        }`}
                    >
                      {link.title}
                    </span>
                  </Link>
                )}
              </div>
            ))}

            {/* Theme Toggle — Animated */}
            <button 
              onClick={toggleTheme}
              className="ml-2 p-2.5 rounded-full transition-all duration-500 relative overflow-hidden group"
              style={{ 
                background: 'var(--accent-soft)',
                color: 'var(--accent)'
              }}
              aria-label="Toggle Dark Mode"
            >
              <div className="relative w-[18px] h-[18px]">
                <BsSun 
                  size={18} 
                  className={`absolute inset-0 transition-all duration-500 ${isDark ? 'opacity-100 rotate-0' : 'opacity-0 rotate-90'}`}
                />
                <BsMoonStars 
                  size={16} 
                  className={`absolute inset-0 transition-all duration-500 ${isDark ? 'opacity-0 -rotate-90' : 'opacity-100 rotate-0'}`}
                  style={{ margin: '1px' }}
                />
              </div>
            </button>

            {/* CTA Button */}
            <Link
              to="/contactus"
              id="nav-cta-button"
              className="btn-nav-solid-blue ml-4"
            >
              Get Started
            </Link>
          </div>

          {/* Mobile Nav */}
          <MobileNavbar />
        </div>
      </div>
    </nav>
  );
}
